// extracted by mini-css-extract-plugin
export var tpaPoints = "four-points-module--tpa-points--g-r0O";
export var fourPoints = "four-points-module--four-points--GEyY1";
export var onePoint = "four-points-module--one-point--daQ2C";
export var onePointName = "four-points-module--one-point-name--itvnv";